<div
  class="widget full-page-widget container"
  [ngClass]="{
    'full-page-widget p-3': !compact(),
    'flex flex-column': compact(),
  }"
  *appHasPermission="{
    permissions: [permissions.allPermissions.REPAIR_REQUEST_READ],
  }"
>
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (compact()) {
    <p-table
      [columns]="COMPACT_COLUMNS"
      [value]="repairs"
      class="p-datatable-sm tableHeaderAlignTop fullTable p-1"
      [scrollable]="true"
      scrollHeight="flex"
      [loading]="loading()"
    >
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th>
              {{ col.header | translate }}
            </th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns">
        <tr class="fixedHeightRow">
          @for (col of columns; track col) {
            @switch (col.field) {
              @case ("gateSystem") {
                <td
                  class="cursorDefault"
                  [pTooltip]="
                    gateIdentifierPipe.transform(
                      rowData.gateSystem,
                      permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)
                    )
                  "
                  tooltipPosition="left"
                >
                  {{ rowData[col.field]["label"] }} ...
                </td>
              }
              @case ("status") {
                <td>
                  {{ "repairs.status" + (rowData[col.field] | repairStatus) | translate }}
                </td>
              }
              @case ("timestamp") {
                <td>
                  {{ rowData[col.field][col.subField] | date: DATE_FORMAT }}
                </td>
              }
              @default {
                <td>
                  {{ rowData[col.field] }}
                </td>
              }
            }
          }
        </tr>
      </ng-template>
    </p-table>
    <div class="footerRow flex align-items-center p-3 justify-content-between">
      <span>
        {{
          "repairs.table.compact_page_report"
            | translate
              : {
                  first: repairs.length > 0 ? 1 : 0,
                  last: repairs.length,
                  totalRecords: totalRepairRecords,
                }
        }}
      </span>
      <a class="viewAllButton" (click)="goToRepairs()">
        {{ "repairs.table.show_all" | translate }}
      </a>
    </div>
  } @else {
    <p-table
      [columns]="FULL_COLUMNS"
      [value]="repairs"
      [paginator]="true"
      [scrollable]="true"
      [rows]="rows"
      [rowsPerPageOptions]="paginatorOptions.ROWS_PER_PAGE"
      class="fullTable p-datatable-sm"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="'common.page_report' | translate"
      [lazy]="true"
      [lazyLoadOnInit]="false"
      [totalRecords]="totalRepairRecords"
      [first]="first"
      [loading]="loading()"
      (onLazyLoad)="onLazyLoad($event)"
    >
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th>
              {{ col.header | translate }}
            </th>
          }
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns">
        <tr class="fixedHeightRow">
          @for (col of columns; track col) {
            @switch (col.field) {
              @case ("gateSystem") {
                <td
                  class="cursorDefault"
                  [pTooltip]="
                    gateIdentifierPipe.transform(
                      rowData.gateSystem,
                      permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)
                    )
                  "
                  tooltipPosition="left"
                >
                  {{ rowData[col.field]["label"] }} ...
                </td>
              }
              @case ("status") {
                <td>
                  {{ "repairs.status" + (rowData[col.field] | repairStatus) | translate }}
                </td>
              }
              @case ("timestamp") {
                <td>
                  {{ rowData[col.field][col.subField] | date: DATE_FORMAT }}
                </td>
              }
              @default {
                <td>
                  @if (col.subField) {
                    {{ rowData[col.field][col.subField] }}
                  } @else {
                    {{ rowData[col.field] }}
                  }
                </td>
              }
            }
          }
          <td class="iconContainer">
            <app-svg-icon
              (click)="onDetailClick(rowData.id)"
              iconName="eye"
              iconColor="primary"
              class="pointer"
            ></app-svg-icon>
            @switch (rowData.status) {
              @case (repairStatus.Created) {
                <ng-container
                  *ngTemplateOutlet="createdActionOptions; context: { repairRequestId: rowData.id }"
                ></ng-container>
              }
              @case (repairStatus.InProgress) {
                <ng-container
                  *ngTemplateOutlet="inProgressActionOptions; context: { repairRequestId: rowData.id }"
                ></ng-container>
              }
              @default {}
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>

<ng-template #createdActionOptions let-repairRequestId="repairRequestId">
  <app-svg-icon
    (click)="onActionClick('InProgress', repairRequestId)"
    iconName="check"
    iconColor="primary"
    class="pointer"
    tooltipPosition="top"
    [pTooltip]="translate.instant('repairs.table.actions.confirm')"
  ></app-svg-icon>
  <app-svg-icon
    *appHasPermission="{
      permissions: [permissions.allPermissions.REPAIR_REQUEST_UPDATE],
    }"
    (click)="onActionClick('Rejected', repairRequestId)"
    iconName="x"
    iconColor="primary"
    class="pointer"
    iconSize="m"
    tooltipPosition="top"
    [pTooltip]="translate.instant('repairs.table.actions.reject')"
  ></app-svg-icon>
</ng-template>

<ng-template #inProgressActionOptions let-repairRequestId="repairRequestId">
  <app-svg-icon
    *appHasPermission="{
      permissions: [permissions.allPermissions.REPAIR_REQUEST_UPDATE],
    }"
    (click)="onActionClick('Completed', repairRequestId)"
    [pTooltip]="translate.instant('repairs.table.actions.complete')"
    life="10000"
    tooltipPosition="top"
    tooltipStyleClass="tooltip"
    iconName="double_check"
    iconColor="primary"
    class="pointer"
  ></app-svg-icon>
</ng-template>
